<template>
  <div>
    <div class="c-aed-status">
      <div
        class="o-grid o-grid--direction-column o-grid--align-items-center o-grid--justify-content-start"
      >
        <div class="o-grid__group">
          <div class="c-aed-status__item o-grid__item o-grid__item--12">
            <span class="c-aed-status__item-name">
              {{ translationsStatus.handledBy }}
            </span>
            <span class="c-aed-status__item-value">{{
              translationsStatus.workflow[all.workflowState] ||
                all.workflowState
            }}</span>
          </div>
          <div class="c-aed-status__item o-grid__item o-grid__item--12">
            <span class="c-aed-status__item-name">
              {{ translationsStatus.created }}
            </span>
            <span class="c-aed-status__item-value">{{
              all.created | formatDate("DD. MMM. YYYY")
            }}</span>
          </div>
          <div class="c-aed-status__item o-grid__item o-grid__item--12">
            <span class="c-aed-status__item-name">
              {{ translationsStatus.status }}
            </span>
            <span class="c-aed-status__item-value">{{
              translationsStatus.known[all.isKnown] || all.isKnown
            }}</span>
          </div>
          <div
            v-if="all.baseDefibrillator"
            class="c-aed-status__item o-grid__item o-grid__item--12"
          >
            <span>
              <router-link
                :to="{
                  name: 'Home',
                  query: { aed: all.baseDefibrillator }
                }"
                class="o-link"
                target="_blank"
                >{{ translationsCustom.seeDefibrillator || "" }}</router-link
              >
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="all.sameAddressReports.length > 0">
      <div
        class="o-heading o-heading--bold o-heading--size-3 o-heading--section o-heading--border o-heading--margin-top"
      >
        {{
          translationsCustom.otherReportsOnAddress ||
            "Other reports on this address"
        }}
      </div>
      <div
        class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
      >
        <div class="o-grid__group">
          <div
            v-for="sameReport in all.sameAddressReports"
            :key="sameReport.baseDefibrillator"
            class="o-grid__item o-grid__item--12"
          >
            <router-link
              :to="{
                name: 'Tips',
                query: {
                  id: sameReport.id,
                  isKnown: sameReport.isKnown ? 1 : 0
                }
              }"
              class="o-link"
              target="_blank"
              >{{ sameReport.id }} ({{
                sameReport.created | formatDate("DD. MMM. YYYY")
              }}) -
              {{
                translationsStatus.workflow[sameReport.workflowState] ||
                  sameReport.workflowState
              }}</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "c-aed-status-report",
  data() {
    return {};
  },
  methods: {
    assignToMe() {
      const payload = {
        api: this.$api,
        method: "PUT",
        id: this.$store.state.tip.all.id,
        section: "assignee",
        data: this.userInfo.Id
      };
      const { dispatch } = this.$store;
      dispatch("tip/setSection", payload);
    }
  },
  computed: {
    ...mapState("translations", {
      translationsStatus: "status",
      translationsCustom: "custom"
    }),
    ...mapState("authentication", ["userInfo"]),
    ...mapGetters("tip", ["status", "all"])
  }
};
</script>
<style lang="scss">
.c-aed-status {
  background-color: $s-cp-neutral-800;
  padding: toRem(30px);

  line-height: toRem(20px);
  &__item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 5px;
  }

  &__item-name {
    width: 35%;
    @include setStyles("14", $s-typography-sizes);
    margin: toRem(2px 0);
    color: $s-cp-neutral-300;
    margin-right: toRem(20px);
  }

  &__item-value {
    width: 65%;
    @include setStyles("15", $s-typography-sizes);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &--updated {
      * {
        white-space: normal;
        &:last-child {
          color: $s-cp-neutral-400;
        }
      }
    }
  }
  &__item-assign {
    color: $s-cp-sup-blue;
    cursor: pointer;
    width: auto;
  }
}
</style>
